/* Copyright(c) 2019 APSS Media Pvt. Ltd.
 *  All Rights Reserved
 */

/*@author Anshul Sarade 5907
 *@fileName :pncTMVoiceLogReview.js
 *Desc: Voice Log Review for PNC-TM role
 */

import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { logoutUser } from "../login/authentication";
import { withRouter } from "react-router-dom";
import Footer from "../layouts/footer";
import PublisherNavigation from "../layouts/publisherNavPage";
import { Table, Tooltip, Icon, Badge, Button, Input, Empty, Pagination } from "antd";//Anshul-5935:added pagination
import { FaArrowAltCircleLeft, FaLink, FaSearch } from "react-icons/fa";
import { css } from "emotion";
import { fetch_custom as fetch } from "../../configration/fetch_default_headers";
import "../campaign/loader.css";//Anshul-5935:added loader
import "./pncTMVoiceLogReview.css";
import { saveAs } from "file-saver"; //Anshul-5977: added file-saver for saving file after processing with xlsx-populate
const Swal = require("sweetalert2");

const tableCSS = css({
    backgroundColor: "white",
    borderStyle: "bold",
    "& thead  > tr": {
        backgroundImage: "linear-gradient(to right,#28166f,#007cc3)!important",
        color: "white",
        fontSize: "12px",
        fontWeight: "500",
    },
    "& thead > tr >th": {
        border: "1px solid black",
        height: "20%",
        color: "white",
    },
});

const styles = {
    mainContainer: {
        paddingTop: "100px",
        paddingBottom: "60px",
        minHeight: "100vh",
        backgroundColor: "#f8f9fa"
    },
    headerSection: {
        marginBottom: "30px",
        textAlign: "center"
    },
    headerTitle: {
        fontSize: "28px",
        fontWeight: "600",
        color: "#0A61AD",
        marginBottom: "5px"
    },
    headerSubtitle: {
        fontSize: "14px",
        color: "#666"
    },
    layoutContainer: {
        display: "flex",
        gap: "25px",
        height: "calc(100vh - 280px)"
    },
    leftPanel: {
        flex: "0 0 28%",
        backgroundColor: "white",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        overflowY: "auto",
        padding: "20px"
    },
    campaignTitle: {
        fontSize: "16px",
        fontWeight: "600",
        color: "#0A61AD",
        marginBottom: "15px"
    },
    campaignItem: (selected) => ({
        padding: "12px 15px",
        marginBottom: "10px",
        borderRadius: "6px",
        cursor: "pointer",
        backgroundColor: selected ? "#0A61AD" : "#f8f9fa",
        color: selected ? "white" : "#333",
        border: selected ? "2px solid #0A61AD" : "1px solid #e0e0e0",
        transition: "all 0.3s ease",
        boxShadow: selected ? "0 4px 12px rgba(10, 97, 173, 0.2)" : "none"
    }),
    campaignName: {
        fontSize: "14px",
        fontWeight: "500",
        marginBottom: "4px"
    },
    campaignID: {
        fontSize: "12px",
        opacity: 0.8,
        marginTop: "4px"
    },
    rightPanel: {
        flex: "1",
        backgroundColor: "white",
        borderRadius: "8px",
        boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        padding: "20px",
        display: "flex",
        flexDirection: "column"
    },
    headerBar: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "20px",
        paddingBottom: "15px",
        borderBottom: "2px solid #f0f0f0"
    },
    headerLeft: {
        flex: "1"
    },
    detailsTitle: {
        fontSize: "16px",
        fontWeight: "600",
        color: "#0A61AD",
        marginBottom: "5px"
    },
    leadCount: {
        fontSize: "13px",
        color: "#666"
    },
    searchBox: {
        width: "250px"
    },
    tableContainer: {
        flex: "1",
        overflowY: "auto",
        border: "1px solid #f0f0f0",
        borderRadius: "6px",
        marginBottom: "20px"
    },
    submitSection: {
        display: "flex",
        justifyContent: "flex-end",
        gap: "10px",
        paddingTop: "15px",
        borderTop: "2px solid #f0f0f0"
    },
    emptyState: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100%",
        color: "#999"
    }
};

class PNCTMVoiceLogReview extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            campaigns: [],
            leads: [],
            filteredLeads: [],
            selectedCampID: null,
            selectedFile: null,
            voiceLogLinks: {},
            // loading: false,
            searchText: "",
            uploadErrors: [],
            campaignSearch: "",
            linkValidationErrors: {},
            loader: "", //Anshul- 5935: added loader s
            loader_progress: "",
            campaignLoader: "",
            pageSize: 25,
            currentPage: 1,
        };
    }

    //Anshul-5935: added pagination handlers

    handleChangePageSize = (e) => {
        const pageSize = parseInt(e.target.value, 10) || 25;
        this.setState({ pageSize, currentPage: 1 });
    };

    handleChangePage = (page) => {
        this.setState({ currentPage: page });
    };

    componentDidMount() {
        if (!this.props.auth.isAuthenticated) {
            this.props.history.push("/userLogin");
        } else {
            this.fetchVoiceLogData();
        }
    }

    fetchVoiceLogData = () => {
        // this.setState({ loading: true });
        this.setState({ loader_progress: "loader_campaign_list" });
        fetch("/publisher/getPNCTMVoiceLogLeads", {
            method: "POST",
            headers: { "Content-Type": "application/json" }
        })
            .then((res) => res.json())
            .then((data) => {
                if (data.success) {
                    let selectedCampID = null;
                    let filteredLeads = data.leads;

                    
                    if (data.campaigns && data.campaigns.length > 0) {
                        selectedCampID = data.campaigns[0].campID;
                        filteredLeads = data.leads.filter(lead => lead.campID === selectedCampID);
                    }

                    this.setState({
                        campaigns: data.campaigns,
                        leads: data.leads,
                        filteredLeads: filteredLeads,
                        selectedCampID: selectedCampID,
                        // loading: false
                        loader_progress: ""
                    });
                } else {
                    Swal.fire({
                        text: "Error fetching data",
                        type: "error",
                        confirmButtonText: "Ok"
                    });
                    // this.setState({ loading: false });
                    this.setState({ loader_progress: "" });
                }
            })
            .catch((err) => {
                console.error("Error:", err);
                // this.setState({ loading: false });
                this.setState({ loader_progress: "" });
            });
    };

    handleCampaignSelect = (campID) => {
        const filtered = this.state.leads.filter(lead => lead.campID === campID);
        this.setState({
            selectedCampID: campID,
            filteredLeads: filtered,
            searchText: "",
            voiceLogLinks: {}
        });
    };

    handleCampaignSearch = (e) => {
        const val = e && e.target ? (e.target.value || "") : "";
        this.setState({ campaignSearch: val });
    };

    handleVoiceLinkChange = (leadInfoID, value) => {
        const voiceLogLinks = { ...this.state.voiceLogLinks };
        voiceLogLinks[leadInfoID] = value;
        this.setState({ voiceLogLinks });
    };

    handleSearch = (e) => {
        const raw = e && e.target ? (e.target.value || "") : "";
        const searchText = raw.toString();
        const q = searchText.trim().toLowerCase();

        const filtered = this.state.leads.filter((lead) => {
            const matchCamp = !this.state.selectedCampID || lead.campID === this.state.selectedCampID;
            if (!q) return matchCamp;

            const email = (lead.email || "").toString().toLowerCase();
            const leadInfoId = (lead.leadInfoID || "").toString().toLowerCase();
            const leadId = (lead.leadID || "").toString().toLowerCase();
            const jobTitle = (lead.jobTitle || "").toString().toLowerCase();
            const status = (lead.status || "").toString().toLowerCase();

            const matchSearch =
                email.includes(q) ||
                leadInfoId.includes(q) ||
                leadId.includes(q) ||
                jobTitle.includes(q) ||
                status.includes(q);

            return matchCamp && matchSearch;
        });

        this.setState({ searchText, filteredLeads: filtered });
    };

    submitVoiceLinks = () => {
        const { voiceLogLinks, filteredLeads, selectedCampID } = this.state;
        const linkValidationErrors = {};
        let hasErrors = false;

       
        filteredLeads.forEach((lead) => {
            const link = voiceLogLinks[lead.leadInfoID];

            
            if (link && link.trim()) {
                const fileName = link.split('\\').pop().split('/').pop().trim();
                const email = (lead.email || "").trim();

                // Anshul-5911: Accept NA value (case-insensitive)
                if (fileName.toLowerCase() === "na") {
                    voiceLogLinks[lead.leadInfoID] = "NA";
                } else if (fileName !== email) {

                    linkValidationErrors[lead.leadInfoID] = "This link is not valid. Link should be in email format.";
                    hasErrors = true;
                }
            }
        });

       
        if (hasErrors) {
            this.setState({ linkValidationErrors });
            return;
        }

      
        this.setState({ linkValidationErrors: {} });

      
        const updatedLeads = filteredLeads
            .filter(lead => voiceLogLinks[lead.leadInfoID]) 
            .map(lead => ({
                ...lead,
                voiceLogLink: voiceLogLinks[lead.leadInfoID]
            }));

        if (updatedLeads.length === 0) {
            Swal.fire({
                text: "Please fill at least one voice log link",
                type: "warning",
                confirmButtonText: "Ok"
            });
            return;
        }
        const data = {
            dynamicArray: updatedLeads,
            campID: selectedCampID
        };

        fetch("/leadDownloadDetails/submitVoiceLink", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data)
        })
            .then((res) => res.json())
            .then((response) => {
                if (response.success) {
                    Swal.fire({
                        text: "Voice logs submitted successfully",
                        type: "success",
                        confirmButtonText: "Ok",
                        allowOutsideClick: false,
                        preConfirm: () => {
                            window.location.reload();
                        }
                    });
                }
                //Anshul:5935: removed unwanted popup
                //  else {
                //     Swal.fire({
                //         text: "Error submitting voice logs",
                //         type: "error",
                //         confirmButtonText: "Ok"
                //     });
                // }
            })
            .catch((err) => {
                console.error("Error:", err);
                Swal.fire({
                    text: "Error submitting voice logs",
                    type: "error",
                    confirmButtonText: "Ok"
                });
            });
    };

   
    handleDownload = () => {
            const { filteredLeads, selectedCampID } = this.state;
    
            if (!selectedCampID) {
                Swal.fire({
                    text: "No data to download",
                    type: "error",
                    confirmButtonText: "Ok",
                });
                return;
            }
    
            let campID = selectedCampID;
            // this.setState({ loading: true });
            this.setState({ loader_progress: "loader_campaign_list" });
            fetch(`/leadDownloadDetails/downloadVoiceLogLeads?campID=${campID}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({ campID: selectedCampID })
            })
                .then(async (response) => {
                    if (!response.ok) {
                        throw new Error("Failed to download file");
                    }
                    let filename = `Voice_Log_Details_Leads_${selectedCampID}.xlsx`;
                    const disposition = response.headers.get("content-disposition");
                    if (disposition && disposition.indexOf("filename=") !== -1) {
                        filename = disposition.split("filename=")[1].replace(/['"]/g, "").trim();
                    }
    
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = filename;
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                    window.URL.revokeObjectURL(url);
                    // this.setState({ loading: false });
                    this.setState({ loader_progress: "" });
                })
                .catch((err) => {
                    // this.setState({ loading: false });
                    this.setState({ loader_progress: "" });
                    Swal.fire({
                        text: "Error downloading voice log leads file.",
                        icon: "error",
                        confirmButtonText: "Ok",
                    });
                });
        };
   
    
    handleExcelUpload = (e) => {
        this.setState({ loader_progress: "loader_campaign_list" });
        const file = e.target.files[0];
        if (!file) return;

        const allowedType =
            file.type ===
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

        if (!allowedType) {
            this.setState({
                uploadErrors: ["Only .xlsx Excel file is allowed"],
                loader_progress: ""
            });
            e.target.value = null;
            return;
        }

        const reader = new FileReader();
        const xlsx = require("xlsx");

        reader.onload = (evt) => {
            const data = new Uint8Array(evt.target.result);
            const workbook = xlsx.read(data, { type: "array" });
            const sheet = workbook.Sheets[workbook.SheetNames[0]];
            const excelData = xlsx.utils.sheet_to_json(sheet, {
                defval: "",
                raw: false,
            });

            this.validateUploadedExcel(excelData);
        };

        reader.readAsArrayBuffer(file);
        e.target.value = null;
    };

   
    validateUploadedExcel = (excelData) => {
        const uploadErrors = [];

       
        if (!excelData || excelData.length === 0) {
            this.setState({
                uploadErrors: ["Uploaded Excel file is empty"],
                loader_progress: ""
            });
            return;
        }

        // Required headers
        const requiredHeaders = [
            "Lead Info ID",
            // "Campaign ID",
            // "Email",
            // "Status",
            "Voice Log Link",
        ];

      
        const fileHeaders = Object.keys(excelData[0]);

       
        const missingHeaders = requiredHeaders.filter(
            (h) => !fileHeaders.includes(h)
        );

        if (missingHeaders.length > 0) {
            this.setState({
                uploadErrors: [
                    `Missing header: ${missingHeaders.join(", ")}`,
                ],
                loader_progress: ""
            });
            return;
        }

       
        const uiData = [...this.state.filteredLeads];

       
        if (excelData.length > uiData.length) {
            this.setState({
                uploadErrors: [
                    "Uploaded file contains more leads than allowed",
                ],
                loader_progress: ""
            });
            return;
        }

       
        const uiLeadMap = {};
        uiData.forEach((item) => {
            uiLeadMap[item.leadInfoID] = item;
        });

      
        let invalidLeadFound = false;
        let campaignMismatchFound = false;
        let emailMismatchFound = false;
        let emptyLinkFound = false;
        let invalidLinkFound = false;

        // Anshul-5925:Collect only leads present in the uploaded file
        const updatedLeadsFromExcelSet = {};

        // Validate each row
        excelData.forEach((row) => {
            const lead = uiLeadMap[row["Lead Info ID"]];

            // Lead not found on UI
            if (!lead) {
                invalidLeadFound = true;
                return;
            }

            // Campaign ID empty or mismatch
            // if (
            //     !row["Campaign ID"] ||
            //     String(row["Campaign ID"]) !== String(lead.campID)
            // ) {
            //     campaignMismatchFound = true;
            //     return;
            // }

            // Email empty or mismatch
            // if (
            //     !row.Email ||
            //     row.Email.trim().toLowerCase() !== lead.email.trim().toLowerCase()
            // ) {
            //     emailMismatchFound = true;
            //     return;
            // }

            const voiceLink = row["Voice Log Link"]?.trim();

            // Empty check (still error)
            if (!voiceLink) {
                emptyLinkFound = true;
                return;
            }

            // Accept NA / na (case-insensitive)
            if (voiceLink.toLowerCase() === "na") {
                lead.voiceLogLink = "NA"; // normalize if you want
                // Anshul-5925: taking leads only from excel file which need to update
                updatedLeadsFromExcelSet[lead.leadInfoID] = lead;
                return; // 
            }

            // VoiceLogLink filename must match email
            const fileName = row["Voice Log Link"].split("\\").pop().split("/").pop();
            if (fileName !== lead.email) {
                invalidLinkFound = true;
                return;
            }

            // Valid row → update UI data
            lead.voiceLogLink = row["Voice Log Link"];
            updatedLeadsFromExcelSet[lead.leadInfoID] = lead;
        });

        // Collect errors (ONE per type)
        if (invalidLeadFound) {
            uploadErrors.push("Some LeadInfoID from the uploaded file are not visible on the screen");
        }
        if (campaignMismatchFound) {
            uploadErrors.push("The Campaign ID in the uploaded file does not match the selected campaign");
        }
        if (emailMismatchFound) {
            uploadErrors.push("Email mismatch in the uploaded file are not visible on the screen");
        }
        if (emptyLinkFound) {
            uploadErrors.push("Some voice log links are missing in the uploaded file");
        }
        if (invalidLinkFound) {
            uploadErrors.push(
                "Some voice log links are invalid. Please ensure the Link matches the email address"
            );
        }

        // Stop if errors exist
        if (uploadErrors.length > 0) {
            this.setState({ uploadErrors, loader_progress: "" });
            return;
        }

        // Anshul-5925: updating only UI input lead which are laoded
        const updatedLeadsFromExcel = Object.keys(updatedLeadsFromExcelSet).map(
            (id) => updatedLeadsFromExcelSet[id]
        );

        const voiceLogLinksMap = {};
        updatedLeadsFromExcel.forEach((l) => {
            if (l.voiceLogLink) voiceLogLinksMap[l.leadInfoID] = l.voiceLogLink;
        });

        this.setState(
            (prev) => ({
                filteredLeads: uiData,
                voiceLogLinks: { ...(prev.voiceLogLinks || {}), ...voiceLogLinksMap },
            }),
            () => {
                // Submit only the leads that were present in the uploaded file
                this.submitUploadedVoiceLinks(updatedLeadsFromExcel);
            }
        );
    };

    // Submit uploaded voice links
    submitUploadedVoiceLinks = (dynamicArray) => {
        const { selectedCampID } = this.state;

        const updatedLeads = dynamicArray
            .filter(lead => lead.voiceLogLink) // Only include leads with filled links
            .map(lead => ({
                ...lead,
                voiceLogLink: lead.voiceLogLink
            }));

        if (updatedLeads.length === 0) {
            Swal.fire({
                text: "Please fill at least one voice log link",
                type: "warning",
                confirmButtonText: "Ok"
            });
            return;
        }

        const data = {
            dynamicArray: updatedLeads,
            campID: selectedCampID
        };

        fetch("/leadDownloadDetails/submitVoiceLink", {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(data)
        })
            .then((res) => res.json())
            .then((response) => {
                if (response.success) {
                    Swal.fire({
                        text: "Voice logs submitted successfully",
                        type: "success",
                        confirmButtonText: "Ok",
                        allowOutsideClick: false,
                        preConfirm: () => {
                            window.location.reload();
                        }
                    });
                } 
                //Anshul:5935: removed unwanted popup
                // else {
                //     Swal.fire({
                //         text: "Error submitting voice logs",
                //         type: "error",
                //         confirmButtonText: "Ok"
                //     });
                // }
            })
            .catch((err) => {
                // console.error("Error:", err);
                // Swal.fire({
                //     text: "Error submitting voice logs",
                //     type: "error",
                //     confirmButtonText: "Ok"
                // });
            })
            .finally(() => {
                this.setState({ loader_progress: "" });
            });
    };

    render() {
        const { campaigns, filteredLeads, selectedCampID, searchText, uploadErrors, campaignSearch } = this.state;

        // Filter campaigns by campaignSearch text
        const displayedCampaigns = (campaigns || []).filter(c => {
            if (!campaignSearch || campaignSearch.trim() === "") return true;
            const q = campaignSearch.toString().trim().toLowerCase();
            const campId = (c.campID || "").toString().toLowerCase();
            const clientCampId = (c.clientCampID || "").toString().toLowerCase();
            const name = (c.campaignName || "").toString().toLowerCase();
            return campId.includes(q) || clientCampId.includes(q) || name.includes(q);
        });

        const leadsTableColumns = [
            {
                title: "Lead ID",
                dataIndex: "leadInfoID",
                key: "leadInfoID",
                width: "12%",
                align: "Center",
                render: (text, record) => <div>{record.leadInfoID}</div>
            },
            {
                title: "Campaign ID",
                dataIndex: "campID",
                key: "campID",
                width: "15%",
                align: "Center",
                render: (text, record) => <div>{record.campID}</div>
            },
            {
                title: "Email",
                dataIndex: "email",
                key: "email",
                width: "25%",
                align: "Center",
                render: (text, record) => (
                    <div>
                        <span title={record.email}>{record.email}</span>
                    </div>
                )
            },
            {
                title: "Status",
                dataIndex: "status",
                key: "status",
                width: "15%",
                align: "Center",
                render: (text, record) => <div>{record.status}</div>
            },
            {
                title: "Voice Log Link",
                dataIndex: "leadInfoID",
                key: "voiceLogLink",
                width: "33%",
                align: "Center",
                render: (leadInfoID, record) => (
                    <div>
                        <input
                            type="text"
                            placeholder="Enter voice log URL"
                            value={this.state.voiceLogLinks[leadInfoID] || ""}
                            onChange={(e) => this.handleVoiceLinkChange(leadInfoID, e.target.value)}
                            style={{
                                width: "100%",
                                padding: "6px 8px",
                                border: this.state.linkValidationErrors[leadInfoID] ? "1px solid red" : "1px solid #ccc",
                                borderRadius: "3px",
                                fontSize: "13px",
                                boxSizing: "border-box"
                            }}
                        />
                        {this.state.linkValidationErrors[leadInfoID] && (
                            <div style={{ color: "red", fontSize: "11px", marginTop: "3px" }}>
                                {this.state.linkValidationErrors[leadInfoID]}
                            </div>
                        )}
                    </div>
                )
            }
        ];

        return (
            <div>
                <PublisherNavigation />
                {/* <div className="container-fluid" style={{ paddingTop: "100px", }}> */}\
                <div className="voice-log-wrapper container-fluid" style={{ paddingTop: "100px" }}>
                    <div className="row" style={{ marginBottom: "20px" }}>
                        <div className="col-lg-1" style={{ paddingLeft: "20px" }}>

                        </div>
                        <div className="col-lg-11">
                            <h2 style={{ textAlign: "center", marginTop: "0px" }}>Upload Voice Log</h2>
                        </div>

                        {/* Download and Upload Buttons */}
                        <div className="col-lg-3" style={{ marginLeft: "auto", display: "flex", alignItems: "center", justifyContent: "flex-end", paddingRight: "20px" }}>
                            {/* Hidden file input */}
                            <input
                                type="file"
                                accept=".xlsx,.xls"
                                ref={(ref) => (this.uploadExcelRef = ref)}
                                style={{ display: "none" }}
                                onChange={this.handleExcelUpload}
                            />

                            {/* Download and Upload Icons */}
                            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
                                <img
                                    src="download1.png"
                                    alt="Download"
                                    title="Download Excel"
                                    onClick={this.handleDownload}
                                    style={{ width: "28px", height: "28px", cursor: "pointer" }}
                                />
                                <img
                                    src="upload_file.png"
                                    alt="Upload"
                                    title="Upload Excel"
                                    onClick={() => {
                                        this.setState({ uploadErrors: [] });
                                        this.uploadExcelRef.click();
                                    }}
                                    style={{ width: "28px", height: "28px", cursor: "pointer" }}
                                />
                            </div>
                        </div>
                    </div>

                    {/* <div style={{ display: "flex", gap: "25px", height: "calc(100vh - 200px)" }}> */}
                    <div className="voice-log-layout">
                        {/* Left Panel - Campaigns */}
                        <div style={{
                            flex: "0 0 22%",
                            backgroundColor: "#f8f9fa",
                            border: "1px solid #0A61AD",
                            borderRadius: "4px",
                            overflowY: "auto",
                            padding: "12px",
                            boxSizing: "border-box",
                            maxHeight: "500px"
                        }}>
                            <div className="voice-log-left">
                                {/* //shivani-task 3206- i have added black color for the label as per @Tanuja's suggetion (it was blue in screen)*/}
                                <>
                                    <label
                                        id="Camp_revw_lab"
                                        style={{
                                            fontSize: "17px",
                                            color: "#ee7b07",
                                            marginTop: "10px",
                                            fontWeight: "500",
                                            fontFamily: "roboto",
                                        }}
                                    >
                                        Campaigns:
                                    </label>
                                </>
                            </div>

                            {/* Search Box */}
                            <div style={{ marginBottom: "15px" }}>
                                <input
                                    type="text"
                                    placeholder="Search Campaign"
                                    value={this.state.campaignSearch}
                                    onChange={this.handleCampaignSearch}
                                    style={{
                                        width: "100%",
                                        padding: "8px 12px",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        fontSize: "12px",
                                        boxSizing: "border-box",
                                        backgroundImage: "url(searchIcon.png)",
                                        backgroundPosition: "8px 8px",
                                        backgroundSize: "13px 13px",
                                        backgroundRepeat: "no-repeat",
                                        paddingLeft: "32px"
                                    }}
                                />
                            </div>

                            {/* Campaign List */}
                            <div>
                                {displayedCampaigns.length === 0 ? (
                                    <p style={{ color: "#f70404", fontSize: "12px" }}>No campaigns available</p>
                                ) : (
                                    displayedCampaigns.map((campaign) => (
                                        <div
                                            key={campaign.campID}
                                            onClick={() => this.handleCampaignSelect(campaign.campID)}
                                            style={{
                                                borderBottom: "1px solid #eee",
                                                padding: "5px 15px",
                                            }}
                                            onMouseEnter={(e) => {
                                                if (selectedCampID !== campaign.campID) {
                                                    e.currentTarget.style.color = "#0A61AD";
                                                }
                                            }}
                                            onMouseLeave={(e) => {
                                                if (selectedCampID !== campaign.campID) {
                                                    e.currentTarget.style.color = "#333";
                                                }
                                            }}
                                        >
                                            {/* Anshul-5925: removed # from URL */}
                                            <a
                                                // href="#/" 
                                                href="#"
                                                id={campaign.campID}
                                                onClick={(e) => { e.preventDefault(); this.handleCampaignSelect(campaign.campID); }}
                                                className="campclickelli"
                                            >
                                                {campaign.campID} -{" "}
                                                {campaign.clientCampID} -{" "}
                                                {campaign.campaignName}{" "}
                                            </a>
                                        </div>
                                    ))
                                )}
                            </div>
                        </div>

                        {/* Right Panel - Voice Log Upload */}
                        {/* <div style={{ flex: "1", display: "flex", flexDirection: "column", paddingLeft: "0px" }}> */}
                        <div >
                            {/* Upload Error Messages */}
                            {uploadErrors.length > 0 && (
                                <div style={{
                                    border: "1px solid red",
                                    color: "red",
                                    padding: "8px",
                                    marginBottom: "15px",
                                    borderRadius: "6px",
                                    fontSize: "12px"
                                }}>
                                    <ul style={{ margin: 0, paddingLeft: "18px" }}>
                                        {uploadErrors.map((err, index) => (
                                            <li key={index}>{err}</li>
                                        ))}
                                    </ul>
                                </div>
                            )}

                            <>
                                {/* Header */}
                                <div className="voice-log-right">
                                    <div style={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "space-between",
                                        marginBottom: "10px"
                                    }}>

                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <div style={{ fontWeight: 600, color: '#333' }}>
                                                {selectedCampID ? (
                                                    <>
                                                        Total Leads: <span style={{ fontWeight: 600, color: '#333' }}>{filteredLeads.length}</span>
                                                    </>
                                                ) : null}
                                            </div>
                                        </div>

                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                            <div align="center" id={this.state.loader_progress} ></div>
                                            <input
                                                type="text"
                                                placeholder="Search"
                                                value={searchText}
                                                onChange={this.handleSearch}
                                                style={{
                                                    padding: "6px 10px",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "4px",
                                                    width: "220px",
                                                    fontSize: "12px",
                                                }}
                                            />
                                        </div>
                                    </div>
                                </div>


                                <div style={{ maxHeight: 'calc(100vh - 300px)' }}>
                                    <Table
                                        key={selectedCampID}
                                        className={tableCSS}
                                        columns={leadsTableColumns}
                                        dataSource={(() => {
                                            const { pageSize, currentPage } = this.state;
                                            const start = (currentPage - 1) * pageSize;
                                            const end = start + pageSize;
                                            return (filteredLeads || []).slice(start, end);
                                        })()}
                                        rowKey="leadInfoID"
                                        pagination={false}
                                        size="small"
                                        bordered
                                        // let Ant Table handle vertical scroll so sticky header works
                                        scroll={{ y: 'calc(100vh - 380px)' }}
                                        sticky={{ offsetHeader: 80 }}
                                    />

                                    {/* Footer sticky to table - part of table */}
                                    <div className="table-footer">
                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                                            &nbsp;Records per page : &nbsp;
                                            <select
                                                value={this.state.pageSize}
                                                onChange={this.handleChangePageSize}
                                                className="form-control"
                                                style={{ width: '65px', height: '28px', display: 'inline-block', padding: '4px 6px' }}
                                            >
                                                <option value="25">25</option>
                                                <option value="50">50</option>
                                                <option value="75">75</option>
                                                <option value="100">100</option>
                                            </select>
                                        </div>

                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                            <Pagination
                                                current={this.state.currentPage}
                                                total={filteredLeads.length}
                                                pageSize={this.state.pageSize}
                                                onChange={this.handleChangePage}
                                                showSizeChanger={false}
                                                style={{ display: 'inline-block', marginRight: '8px' }}
                                            />
                                            <div style={{ marginTop: "20px" }}>
                                                <button
                                                    onClick={this.submitVoiceLinks}
                                                    disabled={filteredLeads.length === 0}
                                                    className="btn add-button"
                                                    style={{ height: '34px', padding: '4px 12px' }}
                                                >
                                                    Submit
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </>

                        </div>
                    </div>
                </div>
                <Footer />
            </div>
        );
    }
}

PNCTMVoiceLogReview.propTypes = {
    logoutUser: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired
};

const mapStateToProps = (state) => ({
    auth: state.auth
});

export default connect(mapStateToProps, { logoutUser })(
    withRouter(PNCTMVoiceLogReview)
);
